// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p6RwX","question":"styles_question__dD_It","description":"styles_description__2_but"};